import {applyMiddleware, createStore} from 'redux'
import {composeWithDevTools} from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import {allReducer} from '../reducer/reducer'

export const Store = createStore(
  allReducer,
  composeWithDevTools(applyMiddleware(thunk))
)
